import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { Link, useNavigate } from 'react-router-dom';
import { Badge, Button, Chip, Stack, useMediaQuery, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserInfo } from '../../user/UserSlice';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { selectCartItems } from '../../cart/CartSlice';
import { selectLoggedInUser } from '../../auth/AuthSlice';
import { selectWishlistItems } from '../../wishlist/WishlistSlice';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import TuneIcon from '@mui/icons-material/Tune';
import { selectProductIsFilterOpen, toggleFilters } from '../../products/ProductSlice';



export const Navbar=({isProductList=false})=> {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const userInfo=useSelector(selectUserInfo)
  const cartItems=useSelector(selectCartItems)
  const loggedInUser=useSelector(selectLoggedInUser)
  const navigate=useNavigate()
  const dispatch=useDispatch()
  const theme=useTheme()
  const is480=useMediaQuery(theme.breakpoints.down(480))

  const wishlistItems=useSelector(selectWishlistItems)
  const isProductFilterOpen=useSelector(selectProductIsFilterOpen)

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleToggleFilters=()=>{
    dispatch(toggleFilters())
  }

  const settings = [
    {name:"Home",to:"/"},
    {name:'Profile',to:loggedInUser?.isAdmin?"/admin/profile":"/profile"},
    {name:loggedInUser?.isAdmin?'Orders':'My orders',to:loggedInUser?.isAdmin?"/admin/orders":"/orders"},
    // {name:'Logout',to:"/logout"},
    {name: loggedInUser?.isGuest?'Login':'Logout',to: loggedInUser?.isGuest?"/logout": "/logout"},
  ];

  return (
    <AppBar position="sticky" sx={{backgroundColor:"black",boxShadow:"none",color:"white"}}>
        {/* <Toolbar sx={{p:1,height:"4rem",display:"flex",justifyContent:"space-around"}}> */}

      <Toolbar sx={{
        p: 1,
        height: "5rem",
        display: "flex",
        flexDirection: { xs: 'column', sm: 'row' }, // mobile vertical, desktop horizontal
        justifyContent: "space-around",
        alignItems: "center"
      }}>  

          {/* <Typography variant="h6" noWrap component="a" href="/" sx={{ mr: 2, display: { xs: 'none', md: 'flex' },fontWeight: 700, letterSpacing: '.3rem', color: 'inherit', textDecoration: 'none', }}>
            NUROVA SHOP
          </Typography> */}

        <Typography
          variant="h6"
          // noWrap
          component="a"
          href="/"
          sx={{
            mr: 2,
            display: { xs: 'flex', md: 'flex' }, // xs (mobile) aur md (desktop) dono me show hoga
            fontWeight: 700,
            letterSpacing: '.3rem',
            color: 'inherit',
            textDecoration: 'none',
            fontSize: { xs: '1rem', sm: '1.2rem', md: '1.5rem' } // responsive font size
          }}
        >
          {/* NUROVA SHOP */}
          MjVision
        </Typography>


          <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'center'} columnGap={2}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt={userInfo?.name} src="null" />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >

              {
                loggedInUser?.isAdmin && 
              
                <MenuItem  onClick={handleCloseUserMenu}>
                  <Typography component={Link} color={'text.primary'} sx={{textDecoration:"none"}} to="/admin/add-product" textAlign="center">Add new Product</Typography>
                </MenuItem>
              
              }
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography component={Link} color={'text.primary'} sx={{textDecoration:"none"}} to={setting.to} textAlign="center">{setting.name}</Typography>
                </MenuItem>
              ))}
            </Menu>
            <Typography variant='h6' fontWeight={300}>{is480?`${userInfo?.name.toString().split(" ")[0]}`:`Hey👋, ${userInfo?.name || ''}`}</Typography>
            {loggedInUser.isAdmin && <Button variant='contained'>Admin</Button>}
            <Stack sx={{flexDirection:"row",columnGap:"1rem",alignItems:"center",justifyContent:"center"}}>

            
            {
            cartItems?.length>0 && 
            <Badge  badgeContent={cartItems.length} color='error'
            sx={{
              '& .MuiBadge-badge': {
                fontSize: { xs: '0.6rem', sm: '0.75rem', md: '0.8rem' }, // responsive badge font
                height: { xs: 16, sm: 18, md: 20 },
                minWidth: { xs: 16, sm: 18, md: 20 },
                
              },
            }}
            >
              <IconButton 
              onClick={()=>
                // navigate("/cart")
                window.location.assign("/cart")
            }
               sx={{
                p: { xs: 0.5, sm: 1 }, // smaller padding on mobile
                fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.5rem' },
                color:"white"
              }}>
                <ShoppingCartOutlinedIcon />
                </IconButton>
            </Badge>
            }
            
            {
              !loggedInUser?.isAdmin &&
                  <Stack>
                      <Badge badgeContent={wishlistItems?.length} color='error' 
                       sx={{
                        '& .MuiBadge-badge': {
                          fontSize: { xs: '0.6rem', sm: '0.75rem', md: '0.8rem' }, // responsive badge font
                          height: { xs: 16, sm: 18, md: 20 },
                          minWidth: { xs: 16, sm: 18, md: 20 },
                        },
                      }}>
                          <IconButton 
                          // component={Link} 
                          // to={"/wishlist"}
                          onClick={() =>
                            window.location.assign("/wishlist")
                          }
                           sx={{
                            p: { xs: 0.5, sm: 1 }, // smaller padding on mobile
                            fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.5rem' },
                            color:"white"
                          }}
                          ><FavoriteBorderIcon /></IconButton>
                      </Badge>
                  </Stack>
            }
            {
              isProductList && <IconButton onClick={handleToggleFilters}><TuneIcon sx={{color:isProductFilterOpen?"black":"white"}}/></IconButton>
            }
            
            </Stack>
          </Stack>
        </Toolbar>
    </AppBar>
  );
}